import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class FeatureRequestSearchModel extends BaseModel {
  title = null;
  no = null;
  module_name = null;
  status = null;
  dev_status = null;
  priority = null;
  payment_status = null;

  attributeLabels = {
    title: i18n.t('Title'),
    no: i18n.t('No'),
    module_name: i18n.t('Module'),
    priority: i18n.t('Priority'),
    dev_status: i18n.t('Dev. Status'),
    payment_status: i18n.t('Payment Status'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }

  getFilteredData() {
    return this.toJSON();
  }
}
